import { FormControl, Input, InputAdornment, Switch, TextField, Typography, withStyles, Snackbar } from "@material-ui/core";
import { KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from "../api";
import React, { useEffect, useReducer, useState } from "react";
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function Parameter(props) {
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [listParam, setListParam] = useState([])
    const listBoolean = [
        "Active", "Inactive"
    ]
    const listCodeType = [
        "NUMERIC", "ALPHABET", "ALPHANUMERIC"
    ]

    useEffect(() => {
        props.setShowNotif(true)
        getData()
    }, [])

    const forceUpdate = useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getData = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let listParam = []
                    let listParam2 = []
                    response.data.data.map((item) => {
                        listParam.push({
                            ...item,
                            updateValue: null
                        })
                        // listParam2.push(item)
                    })
                    setListParam(listParam)
                    // setListParamUpdate(listParam2)
                    // forceUpdate()    
                }
            }
        })
    }

    const handleUpdate = () => {
        let params = []
        listParam.map(item => {
            if (item.updateValue !== null) {
                params.push({
                    "id": item.id,
                    "param_code": item.param_code,
                    "param_title": item.param_title,
                    "param_value": item.updateValue,
                    "param_unit": item.param_unit,
                    "remark": item.remark
                })
            }
        })
        let payload = {
            "params": params
        }
        console.log(JSON.stringify(payload));
        api.create().updateParameter(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    window.location.reload()
                } else {
                    if (response.data.data) {
                        if (response.data.data.params) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data.params)
                            setStatusAlert('warning')
                        } else {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert('warning')
                        }
                    }
                }
            }
        })
    }

    const handleChange = (val, item, index) => {
        console.log(listParam[index]);
        // let arrBaru = listParam
        listParam[index].updateValue = val
        // listParamUpdate[index].param_value = val
        // // arrBaru[index].param_value = "c"
        // console.log(listParam[index]);
        // console.log(listParamUpdate[index]);
        // console.log(arrBaru[index]);
    }

    return (
        <div style={{ maxHeight: props.height - 100, overflow: 'scroll', padding: 20, }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ height: '100%', width: '100%', }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                    <div style={{ width: '36%', alignSelf: 'flex-end', borderBottomColor: '#278863', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                        <Typography style={{ alignSelf: 'flex-end', color: '#278863', fontWeight: 'bold' }}>Nama Parameter</Typography>
                    </div>
                    <div style={{ width: '10%', borderBottomColor: '#278863', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                        <Typography style={{ alignSelf: 'flex-end', color: '#278863', fontWeight: 'bold' }}>Current Value</Typography>
                    </div>
                    <div style={{ width: '10%', borderBottomColor: '#278863', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                        <Typography style={{ alignSelf: 'flex-end', color: '#278863', fontWeight: 'bold' }}>Edit Value</Typography>
                    </div>
                    <div style={{ width: '36%', alignItems: 'flex-end', borderBottomColor: '#278863', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                        <Typography style={{ alignSelf: 'flex-end', color: '#278863', fontWeight: 'bold' }}>Catatan</Typography>
                    </div>
                </div>
                {listParam.map((item, index) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                            <div style={{ width: '36%', alignSelf: 'center', alignSelf: 'center' }}>
                                <Typography style={{ alignSelf: 'center' }}>{item.param_title}</Typography>
                            </div>
                            <div style={{ width: '10%', alignSelf: 'center' }}>
                                {item.param_unit === "days" || item.param_unit === "day" ?
                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                        <Input
                                            style={{ width: '100%' }}
                                            id="standard-adornment-weight"
                                            disabled
                                            endAdornment={<InputAdornment position="end">Hari</InputAdornment>}
                                            aria-describedby="standard-weight-helper-text"
                                            inputProps={{
                                                'aria-label': 'weight',
                                            }}
                                            value={item.param_value}
                                        />
                                    </FormControl>
                                    :
                                    item.param_unit === "time24" ?
                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                            <Input
                                                type="time"
                                                style={{ width: '100%' }}
                                                id="standard-adornment-weight"
                                                value={item.param_value}
                                                disabled
                                                // endAdornment={<InputAdornment position="end">Days</InputAdornment>}
                                                aria-describedby="standard-weight-helper-text"
                                                inputProps={{
                                                    'aria-label': 'weight',
                                                }}
                                            />
                                        </FormControl>
                                        :
                                        item.param_unit === "Queue" ?
                                            <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                <Input
                                                    style={{ width: '100%' }}
                                                    id="standard-adornment-weight"
                                                    disabled
                                                    aria-describedby="standard-weight-helper-text"
                                                    inputProps={{
                                                        'aria-label': 'weight',
                                                    }}
                                                    value={item.param_value}
                                                />
                                            </FormControl>
                                            :
                                            item.param_unit === "minutes" ?
                                                <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                    <Input
                                                        style={{ width: '100%' }}
                                                        id="standard-adornment-weight"
                                                        disabled
                                                        aria-describedby="standard-weight-helper-text"
                                                        inputProps={{
                                                            'aria-label': 'weight',
                                                        }}
                                                        endAdornment={<InputAdornment position="end">Menit</InputAdornment>}
                                                        value={item.param_value}
                                                    />
                                                </FormControl>
                                                :
                                                item.param_unit === "second" ?
                                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                        <Input
                                                            style={{ width: '100%' }}
                                                            id="standard-adornment-weight"
                                                            disabled
                                                            aria-describedby="standard-weight-helper-text"
                                                            inputProps={{
                                                                'aria-label': 'weight',
                                                            }}
                                                            endAdornment={<InputAdornment position="end">Detik</InputAdornment>}
                                                            value={item.param_value}
                                                        />
                                                    </FormControl>
                                                    :
                                                    item.param_unit === "km" ?
                                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                            <Input
                                                                style={{ width: '100%' }}
                                                                id="standard-adornment-weight"
                                                                disabled
                                                                aria-describedby="standard-weight-helper-text"
                                                                inputProps={{
                                                                    'aria-label': 'weight',
                                                                }}
                                                                endAdornment={<InputAdornment position="end">Km</InputAdornment>}
                                                                value={item.param_value}
                                                            />
                                                        </FormControl>
                                                        :
                                                        item.param_unit === "m" ?
                                                            <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                <Input
                                                                    style={{ width: '100%' }}
                                                                    id="standard-adornment-weight"
                                                                    disabled
                                                                    aria-describedby="standard-weight-helper-text"
                                                                    inputProps={{
                                                                        'aria-label': 'weight',
                                                                    }}
                                                                    endAdornment={<InputAdornment position="end">m</InputAdornment>}
                                                                    value={item.param_value}
                                                                />
                                                            </FormControl>
                                                            :
                                                            item.param_unit === "integer" || item.param_unit === "time" ?
                                                                <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                    <Input
                                                                        style={{ width: '100%' }}
                                                                        id="standard-adornment-weight"
                                                                        disabled
                                                                        aria-describedby="standard-weight-helper-text"
                                                                        inputProps={{
                                                                            'aria-label': 'weight',
                                                                        }}
                                                                        // endAdornment={<InputAdornment position="end">M</InputAdornment>}
                                                                        value={item.param_value}
                                                                    />
                                                                </FormControl>
                                                                :
                                                                item.param_unit === "celcius" ?
                                                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                        <Input
                                                                            style={{ width: '100%' }}
                                                                            id="standard-adornment-weight"
                                                                            disabled
                                                                            aria-describedby="standard-weight-helper-text"
                                                                            inputProps={{
                                                                                'aria-label': 'weight',
                                                                            }}
                                                                            endAdornment={<InputAdornment position="end">Celcius</InputAdornment>}
                                                                            value={item.param_value}
                                                                        />
                                                                    </FormControl>
                                                                    :
                                                                    item.param_unit === "Kb" || item.param_unit === "kb" ?
                                                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                            <Input
                                                                                style={{ width: '100%' }}
                                                                                id="standard-adornment-weight"
                                                                                disabled
                                                                                endAdornment={<InputAdornment position="end">Kb</InputAdornment>}
                                                                                aria-describedby="standard-weight-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'weight',
                                                                                }}
                                                                                value={item.param_value}
                                                                            />
                                                                        </FormControl>
                                                                        :
                                                                        item.param_unit === "boolean" || item.param_unit === "Boolean" ?
                                                                            <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                                <button style={{
                                                                                    backgroundColor: "transparent",
                                                                                    fontSize: 20,
                                                                                    outline: 'none',
                                                                                    borderColor: 'transparent',
                                                                                    padding: 0
                                                                                }}
                                                                                    disabled
                                                                                >
                                                                                    <IconSwitch checked={item.param_value === "true" ? true : false} />
                                                                                </button>
                                                                            </div>
                                                                            :
                                                                            item.param_unit === "reservation" ?
                                                                                <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                    <Input
                                                                                        style={{ width: '100%' }}
                                                                                        type="number"
                                                                                        id="standard-adornment-weight"
                                                                                        disabled
                                                                                        aria-describedby="standard-weight-helper-text"
                                                                                        inputProps={{
                                                                                            'aria-label': 'weight',
                                                                                        }}
                                                                                        value={item.param_value}
                                                                                    />
                                                                                </FormControl>
                                                                                :
                                                                                item.param_unit === "digit" ?
                                                                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                        <Input
                                                                                            style={{ width: '100%' }}
                                                                                            id="standard-adornment-weight"
                                                                                            disabled
                                                                                            aria-describedby="standard-weight-helper-text"
                                                                                            inputProps={{
                                                                                                'aria-label': 'weight',
                                                                                            }}
                                                                                            value={item.param_value}
                                                                                        />
                                                                                    </FormControl>
                                                                                    :
                                                                                    item.param_unit === "string" ?
                                                                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                            <Input
                                                                                                style={{ width: '100%' }}
                                                                                                id="standard-adornment-weight"
                                                                                                disabled
                                                                                                aria-describedby="standard-weight-helper-text"
                                                                                                inputProps={{
                                                                                                    'aria-label': 'weight',
                                                                                                }}
                                                                                                value={item.param_value}
                                                                                            />
                                                                                        </FormControl>
                                                                                        :
                                                                                        item.param_unit === "string-type" ?
                                                                                            <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                                <Input
                                                                                                    style={{ width: '100%' }}
                                                                                                    id="standard-adornment-weight"
                                                                                                    disabled
                                                                                                    aria-describedby="standard-weight-helper-text"
                                                                                                    inputProps={{
                                                                                                        'aria-label': 'weight',
                                                                                                    }}
                                                                                                    value={item.param_value}
                                                                                                />
                                                                                            </FormControl>
                                                                                            :
                                                                                            null
                                }
                            </div>
                            {item.param_unit === "days" || item.param_unit === "day" ?
                                <div style={{ width: '10%', alignSelf: 'center' }}>
                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                        <Input
                                            style={{ width: '100%' }}
                                            // type="number"
                                            id="standard-adornment-weight"
                                            onChange={(e) => {
                                                handleChange(e.target.value, item, index)
                                            }}
                                            endAdornment={<InputAdornment position="end">Hari</InputAdornment>}
                                            aria-describedby="standard-weight-helper-text"
                                            inputProps={{
                                                'aria-label': 'weight',
                                            }}
                                            // inputProps={{
                                            //     maxLength: 3
                                            // }}
                                        />
                                    </FormControl>
                                </div>
                                :
                                item.param_unit === "time24" ?
                                    <FormControl style={{ alignItems: 'flex-end', width: '10%', alignSelf: 'center' }}>
                                        <Input
                                            type="time"
                                            style={{ width: '100%' }}
                                            id="standard-adornment-weight"
                                            onChange={(e) => {
                                                handleChange(e.target.value, item, index)
                                                forceUpdate()
                                            }}
                                            aria-describedby="standard-weight-helper-text"
                                            inputProps={{
                                                'aria-label': 'weight',
                                            }}
                                        />
                                    </FormControl>
                                    :
                                    item.param_unit === "Queue" ?
                                        <div style={{ width: '10%', alignSelf: 'center' }}>
                                            <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                <Input
                                                    style={{ width: '100%' }}
                                                    id="standard-adornment-weight"
                                                    onChange={(e) => {
                                                        handleChange(e.target.value, item, index)
                                                    }}
                                                    // endAdornment={<InputAdornment position="end">Hari</InputAdornment>}
                                                    aria-describedby="standard-weight-helper-text"
                                                    inputProps={{
                                                        'aria-label': 'weight',
                                                    }}
                                                    // inputProps={{
                                                    //     maxLength: 3
                                                    // }}
                                                />
                                            </FormControl>
                                        </div>
                                        :
                                        item.param_unit === "Kb" || item.param_unit === "kb" ?
                                            <div style={{ width: '10%', alignSelf: 'center' }}>
                                                <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                    <Input
                                                        style={{ width: '100%' }}
                                                        id="standard-adornment-weight"
                                                        onChange={(e) => {
                                                            handleChange(e.target.value, item, index)
                                                        }}
                                                        endAdornment={<InputAdornment position="end">Kb</InputAdornment>}
                                                        aria-describedby="standard-weight-helper-text"
                                                        inputProps={{
                                                            'aria-label': 'weight',
                                                        }}
                                                        // inputProps={{
                                                        //     maxLength: 5
                                                        // }}
                                                    />
                                                </FormControl>
                                            </div>
                                            :
                                            item.param_unit === "minutes" ?
                                                <div style={{ width: '10%', alignSelf: 'center' }}>
                                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                        <Input
                                                            style={{ width: '100%' }}
                                                            id="standard-adornment-weight"
                                                            onChange={(e) => {
                                                                handleChange(e.target.value, item, index)
                                                            }}
                                                            endAdornment={<InputAdornment position="end">Menit</InputAdornment>}
                                                            aria-describedby="standard-weight-helper-text"
                                                            inputProps={{
                                                                'aria-label': 'weight',
                                                            }}
                                                            // inputProps={{
                                                            //     maxLength: 3
                                                            // }}
                                                        />
                                                    </FormControl>
                                                </div>
                                                :
                                                item.param_unit === "second" ?
                                                    <div style={{ width: '10%', alignSelf: 'center' }}>
                                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                            <Input
                                                                style={{ width: '100%' }}
                                                                id="standard-adornment-weight"
                                                                onChange={(e) => {
                                                                    handleChange(e.target.value, item, index)
                                                                }}
                                                                endAdornment={<InputAdornment position="end">Detik</InputAdornment>}
                                                                aria-describedby="standard-weight-helper-text"
                                                                inputProps={{
                                                                    'aria-label': 'weight',
                                                                }}
                                                                // inputProps={{
                                                                //     maxLength: 3
                                                                // }}
                                                            />
                                                        </FormControl>
                                                    </div>
                                                    :
                                                    item.param_unit === "km" || item.param_unit === "Km" ?
                                                        <div style={{ width: '10%', alignSelf: 'center' }}>
                                                            <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                <Input
                                                                    style={{ width: '100%' }}
                                                                    id="standard-adornment-weight"
                                                                    onChange={(e) => {
                                                                        handleChange(e.target.value, item, index)
                                                                    }}
                                                                    endAdornment={<InputAdornment position="end">Km</InputAdornment>}
                                                                    aria-describedby="standard-weight-helper-text"
                                                                    inputProps={{
                                                                        'aria-label': 'weight',
                                                                    }}
                                                                    // inputProps={{
                                                                    //     maxLength: 3
                                                                    // }}
                                                                />
                                                            </FormControl>
                                                        </div>
                                                        :
                                                        item.param_unit === "m" ?
                                                            <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                    <Input
                                                                        style={{ width: '100%' }}
                                                                        id="standard-adornment-weight"
                                                                        onChange={(e) => {
                                                                            handleChange(e.target.value, item, index)
                                                                        }}
                                                                        endAdornment={<InputAdornment position="end">m</InputAdornment>}
                                                                        aria-describedby="standard-weight-helper-text"
                                                                        inputProps={{
                                                                            'aria-label': 'weight',
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </div>
                                                            :
                                                            item.param_unit === "integer" || item.param_unit === "time" ?
                                                                <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                        <Input
                                                                            style={{ width: '100%' }}
                                                                            id="standard-adornment-weight"
                                                                            onChange={(e) => {
                                                                                handleChange(e.target.value, item, index)
                                                                            }}
                                                                            // endAdornment={<InputAdornment position="end">M</InputAdornment>}
                                                                            aria-describedby="standard-weight-helper-text"
                                                                            inputProps={{
                                                                                'aria-label': 'weight',
                                                                            }}
                                                                            // inputProps={{
                                                                            //     maxLength: 3
                                                                            // }}
                                                                        />
                                                                    </FormControl>
                                                                </div>
                                                                :
                                                                item.param_unit === "celcius" ?
                                                                    <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                            <Input
                                                                                style={{ width: '100%' }}
                                                                                id="standard-adornment-weight"
                                                                                onChange={(e) => {
                                                                                    handleChange(e.target.value, item, index)
                                                                                }}
                                                                                endAdornment={<InputAdornment position="end">Celcius</InputAdornment>}
                                                                                aria-describedby="standard-weight-helper-text"
                                                                                inputProps={{
                                                                                    'aria-label': 'weight',
                                                                                }}
                                                                                // inputProps={{
                                                                                //     maxLength: 3
                                                                                // }}
                                                                            />
                                                                        </FormControl>
                                                                    </div>
                                                                    :
                                                                    item.param_unit === "reservation" ?
                                                                        <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                            <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                <Input
                                                                                    style={{ width: '100%' }}
                                                                                    id="standard-adornment-weight"
                                                                                    onChange={(e) => {
                                                                                        handleChange(e.target.value, item, index)
                                                                                    }}
                                                                                    type="number"
                                                                                    aria-describedby="standard-weight-helper-text"
                                                                                    inputProps={{
                                                                                        'aria-label': 'weight',
                                                                                    }}
                                                                                    // inputProps={{
                                                                                    //     maxLength: 3
                                                                                    // }}
                                                                                />
                                                                            </FormControl>
                                                                        </div>
                                                                        :
                                                                        item.param_unit === "boolean" || item.param_unit === "Boolean" ?
                                                                            // <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                            //     <button style={{
                                                                            //         backgroundColor: "transparent",
                                                                            //         fontSize: 20,
                                                                            //         outline: 'none',
                                                                            //         borderColor: 'transparent',
                                                                            //         padding: 0
                                                                            //     }}
                                                                            //         onChange={(e) => {
                                                                            //             let id = listParam[index].updateValue === "true" ? "false" : "true"
                                                                            //             listParam[index].updateValue = id
                                                                            //             console.log(listParam[index]);
                                                                            //             forceUpdate()
                                                                            //         }}
                                                                            //         disabled
                                                                            //     >
                                                                            //         <IconSwitch checked={listParam[index].updateValue === "true" ? true : false} />
                                                                            //     </button>
                                                                            // </div>
                                                                            <Autocomplete
                                                                                options={listBoolean}
                                                                                getOptionLabel={(option) => option}
                                                                                // disableClearable
                                                                                name='role'
                                                                                id="role"
                                                                                onChange={(event, newInputValue) => {
                                                                                    listParam[index].updateValue = newInputValue === "Active" ? "true" : "false"
                                                                                    // listParam[index].updateValue = id
                                                                                    console.log(listParam[index]);
                                                                                    forceUpdate()
                                                                                }}
                                                                                style={{ width: '10%', alignSelf: 'center' }}
                                                                                renderInput={(params) =>
                                                                                    <TextField
                                                                                        {...params}
                                                                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                                                    />
                                                                                }
                                                                            />
                                                                            :
                                                                            item.param_unit === "digit" ?
                                                                                <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                                    <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                        <Input
                                                                                            type="number"
                                                                                            style={{ width: '100%' }}
                                                                                            id="standard-adornment-weight"
                                                                                            onChange={(e) => {
                                                                                                handleChange(e.target.value, item, index)
                                                                                            }}
                                                                                            // endAdornment={<InputAdornment position="end">Hari</InputAdornment>}
                                                                                            aria-describedby="standard-weight-helper-text"
                                                                                            inputProps={{
                                                                                                'aria-label': 'weight',
                                                                                            }}
                                                                                            // inputProps={{
                                                                                            //     maxLength: 3
                                                                                            // }}
                                                                                        />
                                                                                    </FormControl>
                                                                                </div>
                                                                                :
                                                                                item.param_unit === "string" ?
                                                                                    <div style={{ width: '10%', alignSelf: 'center' }}>
                                                                                        <FormControl style={{ alignItems: 'flex-end', width: '100%' }}>
                                                                                            <Input
                                                                                                style={{ width: '100%' }}
                                                                                                id="standard-adornment-weight"
                                                                                                onChange={(e) => {
                                                                                                    handleChange(e.target.value, item, index)
                                                                                                }}
                                                                                                // endAdornment={<InputAdornment position="end">Hari</InputAdornment>}
                                                                                                aria-describedby="standard-weight-helper-text"
                                                                                                inputProps={{
                                                                                                    'aria-label': 'weight',
                                                                                                }}
                                                                                                // inputProps={{
                                                                                                //     maxLength: 3
                                                                                                // }}
                                                                                            />
                                                                                        </FormControl>
                                                                                    </div>
                                                                                    :
                                                                                    item.param_unit === "string-type" ?
                                                                                        <Autocomplete
                                                                                            options={listCodeType}
                                                                                            getOptionLabel={(option) => option}
                                                                                            // disableClearable
                                                                                            name='code'
                                                                                            id="code"
                                                                                            onChange={(event, newInputValue) => {
                                                                                                listParam[index].updateValue = newInputValue
                                                                                                // listParam[index].updateValue = id
                                                                                                console.log(listParam[index]);
                                                                                                forceUpdate()
                                                                                            }}
                                                                                            style={{ width: '10%', alignSelf: 'center' }}
                                                                                            renderInput={(params) =>
                                                                                                <TextField
                                                                                                    {...params}
                                                                                                    InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                                                                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                                                                                />
                                                                                            }
                                                                                        />
                                                                                        :
                                                                                        null
                            }

                            <div style={{ width: '36%', alignSelf: 'center', alignItems: 'flex-end' }}>
                                <Typography>{item.remark}</Typography>
                            </div>
                        </div>
                    )
                })}


                <div style={{ marginTop: 40, display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ backgroundColor: '#278863', borderRadius: 30, padding: 6, width: 168, textAlign: 'center', cursor: 'pointer' }}
                        onClick={() => {
                            handleUpdate()
                        }}>
                        <Typography style={{ color: 'white', fontSize: 20 }}>Simpan</Typography>
                    </div>
                </div>
            </div>
        </div>
    )
}